<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				name="投标流程"
				label="投标流程"
				placeholder="选择投标流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择投标流程' }]"
			/>
			<van-field
				v-model="form.xmmc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目名称' }]"
			/>
			<van-field
				v-model="form.xmbh"
				label="项目编号"
				placeholder="输入项目编号"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目编号' }]"
			/>
			<van-field
				v-model="client_id_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.select = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="form.gwgg"
				label="挂网公告"
				placeholder="输入挂网公告"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入挂网公告' }]"
			/>
			<van-field
				v-model="type_text"
				name="投标类型"
				label="投标类型"
				placeholder="选择投标类型"
				readonly
				@click="popup.tb_type = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择投标类型' }]"
			/>
			<van-field
				v-model="form.time_date"
				name="开标日期"
				label="开标日期"
				placeholder="选择开标日期"
				readonly
				@click="popup.time_date = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择开标日期' }]"
			/>
			<van-field
				v-model="form.tbgs_name"
				name="投标公司名称"
				label="投标公司名称"
				placeholder="输入投标公司名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入投标公司名称' }]"
			/>
			<van-field
				v-model="tbtype_text"
				name="投标性质"
				label="投标性质"
				placeholder="选择投标性质"
				readonly
				@click="popup.tbtype = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择投标性质' }]"
			/>
			<van-field
				v-model="form.bsgmr"
				label="标书购买和投标人"
				placeholder="输入该项目标书购买和投标人"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入该项目标书购买和投标人' }]"
			/>
			<van-field
				v-model="form.remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写备注' }]"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader
						v-model="uploader"
						:max-count="6"
						:after-read="onAfterRead"
						accept="all"
					/>
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<van-popup v-model="popup.tbtype" position="bottom">
			<van-picker
				show-toolbar
				:columns="tbtypeList"
				@cancel="picker.tbtype = false"
				@confirm="confirm_tbType"
			/>
		</van-popup>
		<van-popup v-model="popup.tb_type" position="bottom">
			<van-picker
				show-toolbar
				:columns="typeList"
				@cancel="picker.tb_type = false"
				@confirm="confirmType"
			/>
		</van-popup>
		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="picker.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.time_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				@cancel="popup.time_date = false"
				@confirm="confirmStartTime"
			/>
		</van-popup>
		<van-popup v-model="popup.select" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onload"
				@check="check"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import popupselect from "@/components/select/index";
import { getNowFormatDateTime } from "@/utils/tool";
import { getList } from "@/api/review";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 

export default {
	name: "Tender",
	components: {
		"popup-select": popupselect
	},
	data() {
		return {
			uploader: [],
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			client_id_text: "",
			date: "",
			type_text: "",
			tbtype_text: "",
			minDate: new Date(),
			form: {
				client_id: "",
				time_date: "",
				xmmc: "",
				xmbh: "",
				gwgg: "",
				tbgs_name: "",
				bsgmr: "",
				remark: ""
			},
			popup: {
				time_date: false,
				tb_type: false,
				calendar: false,
				process: false,
				tbtype: false,
				select: false
			},
			processList: [],
			typeList: [
				{ text: "电子标", id: 0 },
				{ text: "现场标", id: 1 },
			],
			tbtypeList: [
				{ text: "主标", id: 0 },
				{ text: "陪标", id: 1 },
			],
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25
			},
			signTime: true
		};
	},
	mounted() {
		this.getLeaveList();
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("process_id", this.process_id);
			formData.append("requestType", "process_apply");
			formData.append("apply_data",JSON.stringify(this.form));
			formData.append("apply_rmb", "0");
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						Toast.fail("提交成功!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		confirmType(value) {
			this.type_text = value.text;
			this.form.tb_type = value.id;
			this.popup.tb_type = false;
		},
		confirm_tbType(value) {
			this.tbtype_text = value.text;
			this.form.tbtype = value.id;
			this.popup.tbtype = false;
		},
		confirmStartTime(val) {
			this.form.time_date = getNowFormatDateTime(val);
			this.popup.time_date = false;
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		getLeaveList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.client_id_text = "";
			this.type_text = "";
			this.tbtype_text = "";
		},
		check(value) {
			this.popup.select = false;
			this.client_id_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		onload(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			if (search != undefined) {
				this.clientList.page = 1;
			}
			getList({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		}
	}
};
</script>
<style lang="scss">
#details_application {
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
}
</style>